import { useEffect, useState } from 'react'
import { RootState, useAppDispatch, useAppSelector } from '../../redux/store'
import { fetchSignedUrl, selectImageError, selectImageLoading } from '../../redux/image/imageSlice'

export const useFetchImageUrl = (
  fileType: string,
  fileName: string | null,
  moduleName: string,
  shouldFetch: boolean,
) => {
  const dispatch = useAppDispatch()
  const [imageUrl, setImageUrl] = useState<string>('')
  const loading = useAppSelector((state: RootState) => selectImageLoading(state))
  const error = useAppSelector((state: RootState) => selectImageError(state))

  useEffect(() => {
    if (!shouldFetch || !fileName) return

    const getSignedUrl = async () => {
      try {
        const response = await dispatch(fetchSignedUrl({ fileType, fileName, moduleName }))
        if (response.meta.requestStatus === 'fulfilled') {
          setImageUrl(response.payload)
        }
      } catch (err) {
        console.error('Error fetching signed URL:', err)
      }
    }

    getSignedUrl()
  }, [dispatch, fileName, shouldFetch])

  return { imageUrl, loading, error }
}
